/*eslint-disable max-lines*/
import React, { useContext, useEffect, useRef, useState } from 'react';
import { PropTypes } from 'prop-types';
import MessagesContext from '../../../contexts/messagesContext';
import { MainDialog, Options } from '../../UI';
import LanguageContext from '../../../contexts/languageContext';
import { getAccessToken, getNamespace, getRefreshToken } from '../../../utils/storage';
import { baseUrl } from '../../../constants';
import DeleteFormDialog from './DeleteFormDialog';
import {
    createFormReport,
    getFormReport,
    getForms
} from '../../../redux/DynamicForms/DynamicFormsAction';
import { useDispatch } from 'react-redux';
import { styles } from './formRow.styles';
import { Draggable } from 'react-beautiful-dnd';
import moveIcon from '../../../assets/images/Icon/moveIcon.svg';
import { getFullDate, getTime } from '../../../utils/dateTimeUtil';
import NewForm from './NewForm';
import { AddIcon, ArrowBottomIcon, EditIcon } from '../../UI/Images/Icons';
import CreateReport from '../DownloadReports/createReport';
import downloadIcon from '../../../assets/images/Icon/blueDownload.svg';
import AddClinic from './AddClinic';

const FormRow = ({ form, index }) => {
    const namespace = getNamespace();
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const [deleteDialog, setDeleteDialog] = useState(false);
    const dispatch = useDispatch();
    const timer = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [editToggle, setEditToggle] = useState(false);
    const [clinicToggle, setClinicToggle] = useState(false);
    // const [showOption, setShowOption] = useState(false);
    // const [reportsDialog, setReportsDialog] = useState(false);
    // const allForms = useSelector((state) => state.dynamicForms.allForms);
    const options = [
        { label: messages.editFormInfo, icon: 'editName', value: 1 },
        { label: messages.delete, icon: 'delete', value: 2 }
    ];

    const openEditFormWindow = () => {
        const targetURL = process.env.REACT_APP_FORM_EDITOR_URL;
        const apiURL = baseUrl;
        const editFormPath = `/form/f/${form.name}`;
        const uploadMediaEndpoint = `${baseUrl}/form/f/${form.name}/structure_file`;
        if (targetURL && editFormPath && apiURL) {
            window.location.assign(
                `${targetURL}?formURI=${apiURL}${editFormPath}&formName=${
                    form.name
                }&uploadURL=${uploadMediaEndpoint}&origin=${
                    window.location.href
                }&lang=${lang}&access=${getAccessToken()}&refresh=${getRefreshToken()}`
            );
        }
    };

    const handleCreateFormReport = (value) => {
        const param = {
            ...value,
            separator: ';',
            flat: value?.flat === 'true' ? true : false
        };
        if (isLoading) {
            return;
        } else {
            setIsLoading(true);
            dispatch(createFormReport(form.name, param, value.clinic));
        }
    };

    useEffect(() => {
        if (form?.export_status === 'G') {
            setIsLoading(false);
        }
    }, [form]);

    useEffect(() => {
        if (form.name) {
            if (isLoading || form?.export_status === 'D') {
                const params = { include_non_concrete: true };
                timer.current = setInterval(() => dispatch(getForms(namespace, params)), 10000);
                return () => {
                    clearInterval(timer.current);
                };
            }
        }
    }, [isLoading, form]);

    const handleSelectOptions = (option) => {
        const { value } = option;
        if (value === 1) {
            setEditToggle(true);
        } else if (value === 2) {
            setDeleteDialog(true);
        }
    };

    const saveFile = async () => {
        if (form?.export_status === 'G') {
            const response = await dispatch(getFormReport(form?.name));
            if (!response?.data) return;
            const file = response?.data;
            const url = window.URL.createObjectURL(new Blob([file]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${form?.title}.xlsx`);
            document.body.appendChild(link);
            link.click();
        }
    };

    const handleEditToggle = () => {
        if (editToggle) {
            setEditToggle(false);
        } else if (clinicToggle) {
            setClinicToggle(false);
        }
    };
    // const handleDeleteExport = (formName) => {
    //     dispatch(deleteFormExport(formName));
    // };

    const concrete = !('concrete' in form) || form.concrete === true;

    return (
        <>
            <DeleteFormDialog
                deleteDialog={deleteDialog}
                setDeleteDialog={(state) => setDeleteDialog(state)}
                formName={form?.name}
                title={form?.title}
            />
            <Draggable draggableId={String(index)} index={index}>
                {(provided, snapshot) => (
                    <>
                        <div
                            className={classes.formRow}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                        >
                            <div
                                className={`${classes.formNameWrapper} ${
                                    snapshot.isDragging && classes.formFocus
                                } `}
                            >
                                {/* {hoverOption && ( */}
                                <div className={classes.optionRow}>
                                    {/* </div> */}
                                    <div className={`${classes.column} ${classes.infoContainer}`}>
                                        <div className={classes.row}>
                                            <img
                                                src={moveIcon}
                                                alt="move"
                                                className={classes.moveIcon}
                                                {...provided.dragHandleProps}
                                            />
                                            <span className={classes.formName}>{form.title}</span>
                                        </div>
                                        <div className={classes.overallInfo}>
                                            <div className={classes.description} dir="auto">
                                                <span>{form.description}</span>
                                            </div>
                                            <div className={classes.clinicsContainer}>
                                                {form?.clinics?.map((item) => (
                                                    <div className={classes.clinic} key={item.id}>
                                                        {item.name}
                                                    </div>
                                                ))}
                                                <div
                                                    className={classes.addClinic}
                                                    onClick={() => setClinicToggle(true)}
                                                >
                                                    <AddIcon
                                                        color="#509ffa"
                                                        width="16"
                                                        height="16"
                                                    />
                                                    {messages.addClinic}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.column}>
                                        <div className={classes.ButtonContainer}>
                                            <div>
                                                <button
                                                    className={classes.reportButton}
                                                    disabled={!concrete}
                                                    onClick={openEditFormWindow}
                                                    // data-testid="createReport"
                                                >
                                                    <EditIcon />
                                                    {messages.editFormStructure}
                                                </button>
                                            </div>
                                            <CreateReport
                                                handleCreateReport={handleCreateFormReport}
                                                isDragging={snapshot.isDragging}
                                                isLoading={isLoading}
                                                form={form}
                                            />
                                            <div>
                                                <button
                                                    className={classes.reportButton}
                                                    disabled={
                                                        form.export_status !== 'G' || isLoading
                                                    }
                                                    onClick={saveFile}
                                                    data-testid="downloadReport"
                                                >
                                                    <img src={downloadIcon} alt="downloadIcon" />
                                                    {messages.downloadReports}
                                                </button>
                                            </div>
                                            <div className={classes.option}>
                                                <button
                                                    className={classes.reportButton}
                                                    disabled={!concrete}
                                                >
                                                    <ArrowBottomIcon color="#416ce1" />
                                                    {messages.options}
                                                </button>
                                                <Options
                                                    width={'40px'}
                                                    options={options}
                                                    isSetting
                                                    showIcon
                                                    handleSelect={handleSelectOptions}
                                                />
                                            </div>
                                        </div>
                                        {form?.export_requested_at && (
                                            <div className={classes.dateWrapper}>
                                                <>
                                                    <span>
                                                        {messages.formExportCreatedBy}{' '}
                                                        {form?.export_creator?.first_name}{' '}
                                                        {form?.export_creator?.last_name}{' '}
                                                        {messages.inDate}:
                                                    </span>
                                                    <div className={classes.row}>
                                                        <span>
                                                            {getTime(form?.export_requested_at)}
                                                        </span>
                                                        <span>
                                                            {getFullDate(form?.export_requested_at)}
                                                        </span>
                                                    </div>
                                                </>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </Draggable>
            <MainDialog open={editToggle} title={messages.editFormInfo} goBack={handleEditToggle}>
                <NewForm
                    handleClose={handleEditToggle}
                    isEdit
                    title={form.title}
                    description={form.description}
                    formName={form.name}
                    clinics={form?.clinics}
                />
            </MainDialog>
            <MainDialog
                open={clinicToggle}
                title={messages.addClinic}
                goBack={handleEditToggle}
                minHeight="250"
            >
                <AddClinic
                    formName={form.name}
                    clinics={form?.clinics}
                    handleClose={handleEditToggle}
                />
            </MainDialog>
        </>
    );
};
FormRow.propTypes = {
    form: PropTypes.object,
    index: PropTypes.number
};
export default React.memo(FormRow);
